import { Helmet } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";
import '../../assets/styles/MISExecute.css'
import reportImg from "../../assets/images/MIS Reporting.png";
import dashboardImg from "../../assets/images/Dashboard Management.png";
import automationImg from "../../assets/images/Process Automation.png";
import dataEntryImg from "../../assets/images/Data Entry Management.png";
import analyticsImg from "../../assets/images/Business Analytics.png";

const MIS = () => {
  const navigate = useNavigate();

  const misServices = [
    {
      title: "MIS Reporting",
      description: "Daily, weekly, and monthly reports generated for efficient decision-making and performance tracking.",
      image: reportImg,
      path: "/services/mis/reporting"
    },
    {
      title: "Dashboard Management",
      description: "Interactive dashboards for visualizing KPIs, operational data, and trends in real-time.",
      image: dashboardImg,
      path: "/services/mis/dashboard"
    },
    {
      title: "Process Automation",
      description: "Automating repetitive MIS tasks and data workflows to save time and reduce errors.",
      image: automationImg,
      path: "/services/mis/automation"
    },
    {
      title: "Data Entry Management",
      description: "Standardized data entry protocols and tools for accuracy, consistency, and speed.",
      image: dataEntryImg,
      path: "/services/mis/dataentry"
    },
    {
      title: "Business Analytics",
      description: "Using data models and analytics tools to uncover insights and recommend strategic actions.",
      image: analyticsImg,
      path: "/services/mis/analytics"
    }
  ];

  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> MIS Solutions – BuddyTech Solutions </title>
        <meta name="description" content="Data-driven reporting, dashboards, automation and analytics to optimize business processes." />
        <meta name="keywords" content="MIS, business reporting, analytics" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="MIS Solutions – BuddyTech Solutions" />
        <meta property="og:description" content="Data-driven reporting, dashboards, automation and analytics to optimize business processes." />
        <meta property="og:keywords" content="MIS, business reporting, analytics" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/mis" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MIS Solutions – BuddyTech Solutions" />
        <meta name="twitter:description" content="Data-driven reporting, dashboards, automation and analytics to optimize business processes." />
        <meta name="twitter:keywords" content="MIS, business reporting, analytics" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="mis-container">
        <header className="mis-hero">
          <h1>MIS Execution Services</h1>
          <p>Optimizing data handling, reporting, and analysis for smarter business management.</p>
        </header>
        <section className="mis-services">
          {misServices.map((service, index) => (
            <div className="mis-card" key={index} onClick={() => navigate(service.path)}>
              <img src={service.image} alt={service.title} className="mis-card-img" />
              <div className="mis-card-body">
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <button className="mis-btn">Explore</button>
              </div>
            </div>
          ))}
        </section>
      </div>
    </>
  )
}

export default MIS
